module.exports = __webpack_public_path__ + "assets/img/邮箱红.7e4cfc13.png";